import { uid } from 'quasar'
import axios from 'axios'
import store from '../store'
import { dateUtils } from '@parantion/components'

const { convertDateFormatToISO_8601 } = dateUtils

const baseUrl = () => store.state.parantion.baseUrl

export async function getFiles (id, uid) {
  return axios.get(baseUrl() + '/v51/file', {
    params: {
      foh: id,
      limit: 500,
      uid: uid
    }
  }).then(res => res.data.file)
}

export async function getFileByName (name) {
  return axios.get(baseUrl() + '/v51/file', { params: { name } }).then(res => res.data.file)
}

export async function getFolders (uid) {
  if (uid) {
    return axios.get(baseUrl() + `/v51/folder?uid=${uid}`).then(x => x.data.folder)
  }
  return axios.get(baseUrl() + '/v51/folder').then(res => res.data.folder)
}

export async function createFolder (label, parent_foid) {
  return axios.post(baseUrl() + '/v51/folder', {
    label,
    parent_foid
  })
}

export async function logout () {
  // todo: actually log out; check if @components already does it?
  axios.defaults.headers.common['X-CSRFToken'] = undefined
}

export async function getGroups () {
  return axios.get(baseUrl() + '/v51/group').then(res => res.data.group)
}

export async function getForms () {
  const forms = await axios.get(baseUrl() + '/v51/form', {
    params: { field: ['frm_date_created'] }
  }).then(res => res.data.form)

  for (let form of forms) {
    form = Object.assign(form, form.fields)
    delete form.fields
  }
  return forms
}

export async function getFormsForUser (uh) {
  const forms = await axios.get(baseUrl() + '/v51/form', {
    params: {
      uh,
      field: ['frm_date_created']
    }
  }).then(res => res.data.form)

  for (let form of forms) {
    form = Object.assign(form, form.field)
    delete form.field
  }
  return forms
}

export async function getFormsForGroup (groupname): Promise<Array<any>> {
  const forms = await axios.get(baseUrl() + '/v51/form', {
    params: {
      parent: groupname,
      field: ['frm_date_created']
    }
  }).then(res => res.data.form)

  for (let form of forms) {
    form = Object.assign(form, form.field)
    delete form.field
  }
  return forms
}

export async function updateForm ({ fh, frm_status }) {
  return axios.put(baseUrl() + '/v51/form/' + fh + '/field', {
    field: { frm_status }
  }).then(res => res.data.form)
}

export async function generateReport ({ fh, uh, fileName, folderId, outputFormat, tn }) {
  return axios.post(baseUrl() + '/v51/queue/report', {
    fh,
    uh,
    user: uh,
    filename: fileName,
    output: outputFormat,
    tn,
    foh: folderId
  })
}

export async function getTickets (uh, type?) {
  const tickets = await axios.get(baseUrl() + '/v51/ticket', {
    params: {
      uh,
      detail: ['strReceiverEmail', 'strStartDate', 'strEndDate', 'strAccesscode', 'intLinkType', 'strEmailStatus'],
      type: type
    }
  }).then(res => res.data.ticket)

  for (let ticket of tickets) {
    ticket = Object.assign(ticket, ticket.detail)
    delete ticket.detail
  }
  return tickets
}

export async function createForm ({ module, users, template, frm_label, ...fields }) {
  // todo: check if it really is type: module
  const formHash = await axios.post(baseUrl() + '/v51/form', {
    type: module,
    tn: template,
    uh: users,
    frm_label,
    field: fields
  }).then(res => res.data.form[0])

  const form = (await axios.get(baseUrl() + '/v51/form/' + formHash)).data.form[0]

  if (!Array.isArray(users)) users = [users]

  // GROEID-989: User is added in backend in call BAC-1382
  // await axios.post(baseUrl() + '/v51/form/' + form.fh + '/user', {
  //   uh: users
  // })

  return form
}

export async function addUsersToForm (uh, form) {
  return axios.post(baseUrl() + '/v51/form/' + form.fh + '/users', {
    uh
  })
}

export async function createTask (fh: string, uh) {
  return axios.post(baseUrl() + '/v51/task', {
    fh,
    uh
  }).then(res => res.data)
}

export async function createTicket ({ fh, uh, type, ...details }) {
  details = Object.assign({
    blnProtectByAccesscode: 0,
    blnSendMailAccesscode: 0,
    intLinkType: 0,
    strAccesscode: '',
    strContext: 'gd2.0',
    strStartDate: '2017-11-20 00:00:00',
    strEndDate: '2090-12-31 00:00:00'
  }, details)
  return {
    ticketHash: (await axios.post(baseUrl() + '/v51/ticket', {
      fh: fh,
      uh: uh,
      type,
      detail: details
    })).data.tih,
    recipient: details.strReceiverEmail,
    code: details.strAccesscode,
    write: details.intLinkType === 0
  }
}

export async function updateTicket ({ tih, ...details }) {
  return axios.put(baseUrl() + '/v51/ticket/' + tih + '/detail', {
    detail: details
  }).then(res => res.data)
}

export async function deleteTicket (tickethash) {
  return axios.delete(baseUrl() + '/v51/ticket/' + tickethash).then(res => res.data)
}

export async function getTasks (fh: string) {
  return axios.get(baseUrl() + '/v51/task', { params: { fh } }).then(res => res.data)
}

export async function getUserProfilePhoto (uid) {
  return axios.get(baseUrl() + '/v51/user/' + uid + '/field').then(res => res.data.field)
}

export async function getReport (tid, uid, sid) {
  return axios.get('https://lab.dev.parantion.nl/api/', {
    params: {
      Action: 'GetReport',
      Key: sid,
      Template: tid,
      Uid: uid,
      Output: 'viewlink'
    }
  })
}

export async function getRight (right) {
  return axios.get(baseUrl() + '/v51/right', {
    params: {
      module: 'overall',
      name: Array.isArray(right) ? right : [right]
    }
  }).then(res => res.data.value)
}

export async function getUsersFields (uhList) {
  return axios.get('')
}

export async function getUserFields (uh) {
  return axios.get(baseUrl() + '/v51/user/' + uh + '/field', {
    params: { field: ['gd_ibnaam', 'gd_ibemail', 'birthdate', 'status', 'created'] }
  }).then(res => res.data.field)
}

export async function memberOfGroups (uh) {
  return axios.get('/v51/group/member', {
    params: {
      uh
    }
  }).then(res => res.data.member)
}

export async function createUser ({ username, email, status, role, group, agreement, lastname, ...field }) {
  const user = await axios.post(baseUrl() + '/v51/user', {
    username,
    email,
    status,
    role,
    group,
    agreement,
    lastname,
    field: field
  }).then(res => res.data)

  const folders = await axios.get(baseUrl() + '/v51/folder', {
    params: {
      uh: user.uh
    }
  }).then(res => res.data.folder)

  const foldersToRemove = ['all_exports', 'all_imports']

  folders
    .filter(folder => foldersToRemove.includes(folder.label))
    .forEach(folder => {
      axios.delete(baseUrl() + '/v51/folder/' + folder.foid, {
        params: {
          uh: user.uh
        }
      })
    })

  return user
}

export async function inviteTicket (message, tih) {
  return axios.post(baseUrl() + `/v51/ticket/${tih}/invite`, message).then(res => res.data)
}

export async function updateUser (student, fields): Promise<any> {
  const objectified = fields.reduce((acc, [key, value]) => {
    acc[key] = value
    return acc
  }, {})

  return axios.put(baseUrl() + '/v51/user/' + student.uh + '/field', {
    field: objectified
  }).then(res => res.data)
}

/**
 * @param uhList semicolon-separated
 * @param fields semicolon-separated
 */
export async function getFieldsForUserList (uhList, fields) {
  return axios.get(baseUrl() + '/v51/user', {
    params: {
      field: fields,
      uh: uhList
    }
  }).then(res => res.data.user)
}


export async function getStudentsOfGroup (groupName) {
  return axios.get(baseUrl() + `/v51/group/${groupName}/user`).then(res => res.data.user)
}

export async function getGroupByName (name) {
  return axios.get(baseUrl() + `/v51/group/${name}`).then(res => res.data.group)
}

export async function getTemplates (params) {
  return axios.get(baseUrl() + '/v51/template', { params }).then(res => res.data.template)
}

export async function removeStudentFromGroup (studentId, groupName) {
  return axios.delete(baseUrl() + '/v51/group/' + groupName + '/user', { params: { uh: studentId } })
}

export async function addStudentToNewGroup (studentId, groupName) {
  return axios.post(baseUrl() + '/v51/group/' + groupName + '/user', { uh: studentId }).then(res => res.data)
}

export async function checkTask (uh, fh) {
  return axios.get(baseUrl() + `/v51/task?uh=${uh}&fh=${fh}`).then(res => res.data)
}

export async function getReportDefaultFileName (fh, tn) {
  try {
    return await axios.get(baseUrl() + '/v51/queue/report/default', { params: { fh, tn } }).then(res => res.data.filename)
  } catch {
    return false
  }
}

